export const tr = {
    'minus-phrase-list': 'Negatif anahtar sözcük grupları'
};
